import React, { useState, useEffect, Fragment } from "react";
import "./dynamicForm.scss";
import { cdnImage } from "../../../../Shared/helper/constants.js";
import FormField from "./FormFiled/FormFiled.jsx";
import { AIRTEL_WORKS, CHECKBOX, STRING } from "../../constant/constant.js";
import { eventEmitter } from '../../../../Shared/service/google-analytics.service';


const DynamicForm = ({ formSchema, handleSubmit, clearFormData, handleBack,formType,translation }) => {
  const [formData, setFormData] = useState({});
  const [errors, setErrors] = useState({});
  const [searchTerm, setSearchTerm] = useState("");
  const [showOptions, setShowOptions] = useState(false);
  const [eventEmittedFields, setEventEmittedFields] = useState(new Set());

  useEffect(() => {
  eventEmitter(AIRTEL_WORKS,'hbb_lead_form_loaded','page load','hbb_lead_form_loaded',null);
  }, []); 

  const isFormValid = () => {
    const hasErrors = Object.keys(errors).length > 0;
    const hasEmptyRequiredFields = formSchema.fields.some((field) => {
      const value = formData[field.name];
      if (!field.required) return false;
      if (field.type === CHECKBOX) return !value;
      return typeof value !== STRING || value.trim() === '';
    });

    return !hasErrors && !hasEmptyRequiredFields;
  }

  const handleChange = (eventOrValue, fieldName = null) => {
    let name, value;
    const newErrors = { ...errors };

    if (eventOrValue?.target) {
      // Input field
      name = eventOrValue.target.name;
      value = eventOrValue.target.value;
      const field = formSchema.fields.find((f) => f.name === name);
      if (field?.type === CHECKBOX) {
        value = eventOrValue.target.checked;
      } else {
        value = eventOrValue.target.value;
      }
    } else {
      // Dropdown
      name = fieldName;
      value = eventOrValue?.value;
    }
    const field = formSchema.fields.find((f) => f.name === name);
    if (field) {
      const isEmpty = field.type === CHECKBOX ? !value : !value?.trim();
      const patternRegex = new RegExp(field.pattern);

      if (field.required && isEmpty && field.type != "checkbox") {
        newErrors[name] = `${field.label} ${translation.isRequired}`;
      } else if (name === "installationAddress" || name === "landmark") {
        if (!isEmpty) {
          if (field.minLength && value.length < field.minLength) {
            newErrors[name] = field.errorMessage || `${field.label} ${translation.mustBeAtLeast} ${field.minLength} ${translation.characters}`;
          } else if (!patternRegex.test(value)) {
            const onlyNumbers = /^[0-9]+$/.test(value);
            const onlySpecialChars = /^[\-/,\s]+$/.test(value);

            if (onlyNumbers || onlySpecialChars) {
              let message = `${translation.validText}`;
              message += name === "installationAddress" ?`${translation.address}` : `${translation.landmark}`;
              newErrors[name] = message;
            } else {
              newErrors[name] = field.errorMessage || `${translation.invalid} ${field.label}`;
            }
          } else {
            delete newErrors[name];
          }
        } else {
          delete newErrors[name];
        }
      }
      else {
        if (field.minLength && value.length < field.minLength) {
          newErrors[name] = field.errorMessage || `${field.label} ${translation.mustBeAtLeast} ${field.minLength} ${translation.characters}`;
        } else if (field.maxLength && value.length > field.maxLength) {
          newErrors[name] = field.errorMessage || `${field.label} ${translation.mustBeMore} ${field.maxLength} ${translation.characters}`;
        } else if (field.pattern && !patternRegex.test(value)) {
          newErrors[name] = field.errorMessage || `${translation.invalid} ${field.label}`;
        } else {
          delete newErrors[name];
        }
      }
    }
    setFormData((prev) => ({ ...prev, [name]: value }));
    setErrors(newErrors);
    const isFilled = field?.type === 'checkbox' ? value : value?.trim();
    if (isFilled && !eventEmittedFields.has(name)) {
      eventEmitter(AIRTEL_WORKS, `hbb_lead_form_field_${name}_filled`, 'form change', `hbb_lead_form_field_${name}_filled`, null);
      setEventEmittedFields((prev) => new Set(prev).add(name));
    }
  

};


  const handleAction = (event) => {
    const { name, value } = event.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  return (
    <div className={`dynamic-form ${formType}`}>
      <form
        onSubmit={(e) => {
          e.preventDefault();
          handleSubmit(formData);
        }}
      >
        <div className="row">
          {!!formSchema?.fields?.length &&
            formSchema.fields
              .sort((a, b) => (a.rank ?? 0) - (b.rank ?? 0))
              .map((field, index) => (
                <Fragment key={index}>
                 <FormField 
                  field={field}
                  handleChange={handleChange}
                  formData={formData}
                  errors={errors}
                  translation={translation?.customDropdown}
                 />
                </Fragment>
              ))}
        </div>
        <div class="button-wrap">
          {!!formSchema?.actions?.length &&
            formSchema?.actions?.sort((a, b) => (a.rank ?? 0) - (b.rank ?? 0)).map((action, index) => (
              <button
                className={`${action.type === "cancel" ? "back-button" : "btn btn-black"
                  }`}
                key={index}
                type={action.type === "submit" ? "submit" : "button"}
                onClick={action.type === "submit"
                  ? undefined
                  : action.type === "cancel"
                    ? handleBack
                    : handleAction}
                   disabled={action.type === "submit" && !isFormValid()}
              >
                {action.type === "cancel" && (
                  <>
                    {
                      <img
                        // src={`${cdnImage}/assets/images/icons/back-arrow.svg`}
                        src="https://cdn-webportal.airtelstream.net/website/uganda/assets/images/icons/back-arrow.svg"
                        alt={""}
                      />
                    }
                  </>
                )}
                {action.label}
              </button>
            ))}
        </div>
      </form>
    </div>
  );
};

export default DynamicForm;
